// base libraries
require("lodash");
require("moment");
require("numeral");
require("uuid");
require("core-js/fn/promise");

// jquery & plugins
var jQuery = require("jquery");
jQuery.migrateMute = true;
require("jquery-migrate/dist/jquery-migrate");
require("jquery.scrollto");
require("jquery.cookie");
require("jquery-mousewheel");
require("qtip2");
require("jgrowl/jquery.jgrowl.js");
require("spectrum-colorpicker");
require("jquery-file-download/src/Scripts/jquery.fileDownload.js");
require("jquery-jcaret")(jQuery);
require("jquery-fieldselection/jquery-fieldselection.js");

// jquery UI modules
require("jquery-ui/ui/widget");
require("jquery-ui/ui/position");
require("jquery-ui/ui/effect");
require("jquery-ui/ui/widgets/mouse");
require("jquery-ui/ui/widgets/draggable");
require("jquery-ui/ui/widgets/sortable");
require("jquery-ui/ui/widgets/datepicker");

// jquery fileupload
require("blueimp-file-upload/js/jquery.fileupload.js");
require("blueimp-file-upload/js/jquery.fileupload-process.js");
require("blueimp-file-upload/js/jquery.fileupload-validate.js");
require("blueimp-file-upload/js/jquery.fileupload-angular.js");
require("blueimp-file-upload/css/jquery.fileupload.css");
require("blueimp-file-upload/css/jquery.fileupload-ui.css");

// angular
require("angular");
require("angular-route");
require("angular-animate");
require("angular-sanitize");
require("oclazyload");
require("angular-ui-sortable");

// error management
require("stackframe");
require("error-stack-parser");

// highcharts
var highcharts = require("highcharts/highstock.src.js");
require("highcharts/highcharts-more.src.js")(highcharts);
require("highcharts/modules/exporting.src.js")(highcharts);
require("highcharts/modules/solid-gauge.src.js")(highcharts);
require("highcharts/modules/timeline.src.js")(highcharts);

// font awesome
require("@fortawesome/fontawesome-pro/css/all.css");
require("@fortawesome/fontawesome-pro/css/v4-shims.css");

// tinyMCE
import "tinymce/tinymce";
import 'tinymce/themes/modern/theme';
import "tinymce/plugins/autolink";
import "tinymce/plugins/lists";
import "tinymce/plugins/link";
import "tinymce/plugins/paste";
import "tinymce/plugins/colorpicker";
import "tinymce/plugins/textcolor";
import "tinymce/skins/lightgray/skin.min.css";
import "tinymce/plugins/table";

// other
require("./bs-switch/bootstrap-switch.js");
require("./bs-switch/bootstrap-switch.css");
require("pdfobject");

// styles from vendors
require("spectrum-colorpicker/spectrum.css");
require("jgrowl/jquery.jgrowl.css");
require("qtip2/dist/jquery.qtip.css");
require("leaflet/dist/leaflet.css");


//////////////////
// WEBPACK FOOTER
// ./src/vendors/vendors.js
// module id = 3042
// module chunks = 14